import React from 'react'

// When a collapsed section learns one of its descendants is in error it
// auto-expands. Nested sections cascade their aggregate state upward.
export interface IUI2FormSectionErrorContext {
  reportError: (id: string, hasError: boolean) => void
}

const noop: IUI2FormSectionErrorContext = { reportError: () => undefined }

export const UI2FormSectionErrorContext = React.createContext<IUI2FormSectionErrorContext>(noop)
